import { Object3D } from 'three'
import Constants from '../lib/Constants'
import Highlighter from '../lib/Highlighter'
import Layout from './Layout'
import Lights from './Lights'
import Materials from './Materials'
import MegaRaycaster from '../lib/MegaRaycaster'
import Sky from './Sky'
import Trees from './Trees'
import Bottles from './Bottles'

export default class World
{
    constructor(_options)
    {
        this.database = _options.database
        this.ui = _options.ui
        this.debug = _options.debug
        this.time = _options.time
        this.cursor = _options.cursor
        this.resources = _options.resources
        this.camera = _options.camera

        this.materials = new Materials({
            debug: this.debug,
            resources: this.resources
        })

        this.container = new Object3D()
        this.container.name = 'world_container'
        this.container.matrixAutoUpdate = false

        this.init()
    }

    init()
    {
        this.setLights()
        this.setSky()
        this.setLayout()
        this.setTrees()
        this.setBottles()
        setTimeout(() => {
            this.setHighlighter()
            this.setRaycaster()
        }, 10)
    }

    setLights()
    {
        this.lights = new Lights({
            debug: this.debug,
            time: this.time
        })
        this.container.add(this.lights.container)
    }

    setSky()
    {
        this.sky = new Sky({
            time: this.time,
            materials: this.materials
        })
        this.container.add(this.sky.container)
    }

    setLayout()
    {
        this.layout = Layout.init({
            database: this.database,
            resources: this.resources,
            materials: this.materials
        })
        this.container.add(this.layout.container)
        this.ui.layout = this.layout
        this.camera.controls.terrain = this.layout.map
    }

    async setTrees()
    {
        this.trees = await Trees.init({
            layout: this.layout,
            materials: this.materials
        })
        this.container.add(this.trees.container)
    }

    setBottles()
    {
        this.bottles = new Bottles({
            resources: this.resources,
            camera: this.camera,
            materials: this.materials
        })
        this.container.add(this.bottles.container)
    }

    setHighlighter()
    {
        this.highlighter = new Highlighter({
            database: this.database,
            font: this.resources.items.ebGaramond,
            time: this.time,
            ui: this.ui,
            camera: this.camera,
            materials: this.materials,
            layout: this.layout,
            bottles: this.bottles,
            forest: this.trees.forestMesh
        })
        this.container.add(this.highlighter.container)
    }

    setRaycaster()
    {
        const raycastObjects = this.layout.instance.children.concat(this.trees.forestMesh)

        this.megaRaycaster = new MegaRaycaster({
            database: this.database,
            time: this.time,
            ui: this.ui,
            cursor: this.cursor,
            camera: this.camera,
            layout: this.layout,
            bottles: this.bottles,
            raycastObjects: raycastObjects,
            highlighter: this.highlighter
        })
        this.ui.megaRaycaster = this.megaRaycaster
    }
}